import apiUrls from "src/api";

interface AzureTokenResponse {
  token: string;
  region: string;
  expiresAt: number;
}

let cached: AzureTokenResponse | null = null;
let inflight: Promise<AzureTokenResponse> | null = null;

const REFRESH_MARGIN_MS = 60 * 1000;

async function fetchToken(): Promise<AzureTokenResponse> {
  const jwt = localStorage.getItem("wixar.auth.jwt");
  const response = await fetch(apiUrls.voiceMode.azureToken, {
    method: "GET",
    headers: jwt ? { Authorization: `Bearer ${jwt}` } : {},
  });
  if (!response.ok) {
    throw new Error(`Azure token fetch failed: ${response.status}`);
  }
  return (await response.json()) as AzureTokenResponse;
}

export async function getAzureToken(): Promise<AzureTokenResponse> {
  const now = Date.now();
  if (cached && cached.expiresAt - now > REFRESH_MARGIN_MS) {
    return cached;
  }
  if (inflight) {
    return inflight;
  }
  inflight = fetchToken()
    .then((res) => {
      cached = res;
      return res;
    })
    .finally(() => {
      inflight = null;
    });
  return inflight;
}

export function clearAzureTokenCache(): void {
  cached = null;
}
